/* eslint-disable */
import React from 'react';

const toggleOff = () => (
    <svg width="27" height="14" viewBox="0 0 27 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="27" height="14" rx="7" fill="#8E9CB3" />
        <circle cx="7" cy="7" r="6" fill="#242F40" />
    </svg>
);

export default toggleOff;
